<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="magnification" :label="$lang.magnification" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="showOpenAppIndicators" :label="$lang.openAppIndicators" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="autoHide" :label="$lang.autoHide" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><dropdown :class="['mr-1']" v-model="location" :items="locations" width="128px" :ripple-color="$dark ? 'white' : 'gray'" :ripple-color-lightness="$dark ? null : 300" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" /><!--
          --><btn :uppercase="false" :class="['mx-1']" @click="jump" size="xs" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :title="$lang.jump" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.jump }}</btn>
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <macos-dock :key="key" :disabled="disabled" :auto-hide="autoHide" :items="items" :location="location[0]" @item-click="onItemClick" :show-open-app-indicators="showOpenAppIndicators" :item-size="itemSize" :magnification="magnification" />
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageMacosDock',
  mixins: [
    methods
  ],
  data () {
    return {
      key: 0,
      items: [],
      itemSize: 32,
      autoHide: false,
      disabled: false,
      magnification: true,
      showOpenAppIndicators: true,
      location: ['bottom'],
      locations: ['top', 'right', 'bottom', 'left'].map(value => {
        return {
          value,
          text: this.firstLetterCapital(value)
        }
      })
    }
  },
  mounted () {
    this.getExternalData('macos-dock.json', 'items')
  },
  watch: {
    location () {
      this.itemSize = ['left', 'right'].includes(this.location[0]) ? 16 : 32
      this.key++
    }
  },
  methods: {
    onItemClick ($event) {
      this.log('item-click', 'macos-dock', $event)
    },
    jump () {
      this.items.map(item => {
        if (item.notifications !== 0) {
          item.jump = !item.jump
        }
        return item
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/macos-dock.vue